import React from "react";
import { Link } from "react-router-dom";
import { Star } from "lucide-react";
import { useApp } from "../context/AppContext";

const ProductCard = ({ product }) => {
  const { t, tl } = useApp();
  const discount = product.oldPrice
    ? Math.round((1 - product.price / product.oldPrice) * 100)
    : 0;

  return (
    <Link to={`/p/${product.id}`} className="group block">
      <div className="relative overflow-hidden bg-white rounded-sm aspect-[3/4] mb-3">
        <img
          src={product.image}
          alt={tl(product.name)}
          loading="lazy"
          className="img-zoom w-full h-full object-cover"
        />
        {/* Badges */}
        <div className="absolute top-3 left-3 flex flex-col gap-1.5">
          {product.isNew && (
            <span className="bg-[#1b1b1b] text-white text-[10px] tracking-[0.1em] uppercase px-2.5 py-1">
              {t("newBadge")}
            </span>
          )}
          {discount > 0 && (
            <span className="bg-[#8b1e3f] text-white text-[10px] tracking-[0.1em] uppercase px-2.5 py-1">
              -{discount}%
            </span>
          )}
        </div>
      </div>

      <div>
        <div className="flex items-center justify-between gap-2">
          <span className="text-[11px] uppercase tracking-[0.12em] text-muted-foreground">{product.brand}</span>
          <span className="flex items-center gap-1 text-[11px] text-muted-foreground">
            <Star className="h-3 w-3 fill-[#b08d57] text-[#b08d57]" />
            {product.rating}
          </span>
        </div>
        <h3 className="text-[14px] mt-1 text-[#1b1b1b] leading-snug line-clamp-1 group-hover:text-[#b08d57] transition-colors">
          {tl(product.name)}
        </h3>
        <div className="flex items-center gap-2 mt-1.5">
          <span className="text-[15px] font-medium text-[#1b1b1b]">{product.price} €</span>
          {product.oldPrice && (
            <span className="text-[13px] text-muted-foreground line-through">{product.oldPrice} €</span>
          )}
        </div>
        {/* Color swatches */}
        {product.colors?.length > 1 && (
          <div className="flex gap-1.5 mt-2.5">
            {product.colors.slice(0, 5).map((c, i) => (
              <span
                key={i}
                className="h-3.5 w-3.5 rounded-full border border-black/10"
                style={{ backgroundColor: c }}
              />
            ))}
          </div>
        )}
      </div>
    </Link>
  );
};

export default ProductCard;
